import {createAction} from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import {userAccessTokenSelector} from "../../../security";

const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const fetchTaxesRequested: Action = createAction(ActionTypes.FETCH_TAXES_REQUESTED)
export const fetchTaxesReceived: Action = createAction(ActionTypes.FETCH_TAXES_RECEIVED)
export const fetchTaxesFailed: Action = createAction(ActionTypes.FETCH_TAXES_FAILED)

const handleError = (err, dispatch, action) => {
  if(err.message.length && err.message[0].msg && err.message[0].msg === "N/A") {
    dispatch(action("Unauthorized."))
  } else {
    dispatch(action(err.message[0].msg))
  }
}

const fetchAllTaxesAPI = async (options) => await workflowController.findWhere('tax', {}, options)
export const fetchAllTaxes = () => async (dispatch, getState) => {
  dispatch(fetchTaxesRequested())
  try {
    const result = await fetchAllTaxesAPI({token: userAccessTokenSelector(getState())})
    dispatch(fetchTaxesReceived(result))
  } catch (err) {
    handleError(err, dispatch, fetchTaxesFailed)
  }
}

export const configureTaxRequested: Action = createAction(ActionTypes.CONFIGURE_TAX_REQUESTED)
export const configureTaxReceived: Action = createAction(ActionTypes.CONFIGURE_TAX_RECEIVED)
export const configureTaxFailed: Action = createAction(ActionTypes.CONFIGURE_TAX_FAILED)

const configureTaxAPI = async (taxName, taxRate, options) => await workflowController.execute('tax', null, 'configure', {taxName, taxRate:parseFloat(taxRate)}, options)
export const configureTax = (taxName, taxRate) => async (dispatch, getState) => {
  dispatch(configureTaxRequested())
  try {
    await configureTaxAPI(taxName, taxRate, {token: userAccessTokenSelector(getState())})
    dispatch(configureTaxReceived())
    dispatch(fetchAllTaxes())
  } catch (err) {
    handleError(err, dispatch, configureTaxFailed)
  }
}

export const unSetTaxError: Action = createAction(ActionTypes.UNSET_TAX_ERROR)


export const deleteTaxRequested: Action = createAction(ActionTypes.DELETE_TAX_REQUESTED)
export const deleteTaxReceived: Action = createAction(ActionTypes.DELETE_TAX_RECEIVED)
export const deleteTaxFailed: Action = createAction(ActionTypes.DELETE_TAX_FAILED)
const deleteTaxAPI = async (taxId, options) => await workflowController.execute('tax', null, 'delete', {taxId}, options)
export const deleteTax = (taxId) => async (dispatch, getState) => {
  dispatch(deleteTaxRequested())
  try {
    await deleteTaxAPI(taxId, {token: userAccessTokenSelector(getState())})
    dispatch(deleteTaxReceived())
  } catch (err) {
    err.message[0].msg = 'There was a problem deleting taxes.'
    handleError(err, dispatch, deleteTaxFailed)
  }
}


// WEBPACK FOOTER //
// ./src/features/tax/store/taxActions.js